// extracted by mini-css-extract-plugin
export default {"wrapper":"TransitionLayout_wrapper__i6Lrm","fader":"TransitionLayout_fader__PfstR"};